import Joi from 'joi';

export const AuthenticatedHttpErrorSchema = Joi.object({
	error: Joi.object({
		code: Joi.number().required(),
		errors: Joi.array()
			.items({
				code: Joi.number(),
				field: Joi.string(),
				message: Joi.string(),
			}).required(),
		message: Joi.string().required(),
	}).required(),
});
